import React from "react";
import TrainEventRecordDashboard from "./TrainEventRecordDashboard";
import { trainEventAdminSummaryDashboardOverview } from "./TrainEventRecordPageSelector";
import { TrainView } from "./TrainEventRecordView";

export const TrainEventRecordOverview = () => {
    return (
        <TrainEventRecordDashboard
            page={trainEventAdminSummaryDashboardOverview}
            pageView={TrainView.MyForm}
        />
    );
};